import styled from 'styled-components';

import { Tooltip, Box, Typography } from '@mui/material';
import Label from './label';

import { colors } from '../../theme';

interface BorderBoxProps {
    selected: boolean;
    disabled: boolean;
    displayInfo: boolean;
}

const FilterOption = (props: any) => {
    const { data, disabled, name, label, icon, onOptionClick, state, selectedID, onClickValue, displayInfo, displayItem } = props;

    const handleOnClick = (item: any) => {
        if(!onOptionClick) return;

        if (onClickValue) {
            onOptionClick(item[onClickValue]);
        } else onOptionClick(item);
    };
    return (
        <>
            <Container {...props}>
                {label && <Label disabled={disabled} icon={icon} label={label} />}
                {data &&
                    data.map((item: any, index: any) => {
                        return (
                            <BorderBox
                                key={index}
                                disabled={disabled}
                                displayInfo={displayInfo}
                                selected={state === (selectedID ? item[selectedID] : item.value)}
                                style={{ opacity: disabled && 0.3 }}
                                onClick={() => handleOnClick(item)}
                            >
                                <Tooltip title={displayInfo && item[displayItem] ? item[displayItem] : ''}>
                                    <Typography variant="body2">{item[name]}</Typography>
                                </Tooltip>
                            </BorderBox>
                        );
                    })}
            </Container>
        </>
    );
};

export default FilterOption;

const Container = styled(Box)`
    && {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
`;

const BorderBox = styled.div<BorderBoxProps>`
    display: inline-block;
    padding: 3px 7px;
    border-radius: 5px;
    margin-right: 5px;
    margin-bottom: 2px;
    cursor: pointer;

    ${(props) =>
        !props.disabled &&
        !props.selected && {
            '&:hover': {
                border: `1px solid ${colors.blue.main}`,
                color: colors.blue.main,
                background: colors.blue.light,
            },
        }}

    ${(props) =>
        props.selected
            ? `
                background: ${colors.blue.main};
                color: white; 
                border: 1px solid ${colors.blue.main}
    `
            : ` 
             background: white; border: 1px solid ${colors.grey.medium};
    `}

    ${(props) => props.disabled && { opacity: 0.3, cursor: 'default' }}

    ${(props) => props.displayInfo && { cursor: 'default' }}
`;
